<script>
export default {
  name: "IconFacebook"
};
</script>

<template>
  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 10.564C21 4.73 16.299 0 10.5 0S0 4.73 0 10.564C0 15.837 3.84 20.207 8.86 21v-7.383H6.194v-3.053H8.86V8.237c0-2.648 1.568-4.11 3.965-4.11 1.15 0 2.351.206 2.351.206v2.6h-1.324c-1.304 0-1.71.814-1.71 1.65v1.981h2.91l-.464 3.053H12.14V21C17.161 20.207 21 15.837 21 10.564"
      fill="#FFF"
      fill-rule="evenodd"
      opacity=".8"
    />
  </svg>
</template>
